/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { onCLS, onLCP, onINP, onFCP, onTTFB } from 'web-vitals';
import { initSentry } from './sentry.config.js';

// Core Web Vitals → Sentry (lazy import so no Sentry cost when DSN is unset).
function reportVital(metric) {
  if (!process.env.GATSBY_SENTRY_DSN) return;
  import('@sentry/gatsby')
    .then((Sentry) => {
      Sentry.captureMessage(`web-vitals.${metric.name}`, {
        level: 'info',
        tags: { rating: metric.rating },
        extra: {
          value: metric.value,
          id: metric.id,
          navigationType: metric.navigationType,
        },
      });
    })
    .catch(() => {});
}

export const onClientEntry = () => {
  initSentry();

  // Web Vitals — runs on every page. One report per metric per route.
  onCLS(reportVital);
  onLCP(reportVital);
  onINP(reportVital);
  onFCP(reportVital);
  onTTFB(reportVital);
};

// Signals the Google Ads phone-swap (gatsby-ssr.js phoneConversionCallback)
// that React is done hydrating and the DOM is safe to mutate. Rewriting the
// visible number before hydration is what produced the React #418/#423/#425
// mismatch errors Clarity recorded on slow connections, where `load` fires
// before the bundle hydrates.
export const onInitialClientRender = () => {
  if (typeof document === 'undefined') return;
  window.__bfHydrated = true;
  document.dispatchEvent(new Event('bf:hydrated'));
};

export const onRouteUpdate = () => {
  if (typeof window === 'undefined') return;

  // Re-attach the native lead-form helpers (attribution inputs, Turnstile
  // widget, funnel steps, input formatting) to forms rendered by a client-side
  // route change. Each hook is idempotent. See hydratedNativeFormsScript in
  // gatsby-ssr.js.
  setTimeout(() => {
    (window.__bfFormHooks || []).forEach((fn) => {
      try {
        fn();
      } catch (e) {
        /* ignore */
      }
    });
  }, 0);

  // Ping Intercom on client-side navigation so it registers the new page
  // and checks for messages. The launcher shows on EVERY page now — the old
  // hide-on-homepage rule plus the Netlify loader snippet's homepage
  // early-return meant a visitor who landed on the homepage never got the
  // launcher anywhere for the rest of their session. Loading is handled by
  // the deferred INTERCOM_LOADER_SCRIPT in gatsby-ssr.js.
  if (window.Intercom) {
    window.Intercom('update', { hide_default_launcher: false });
  }
};
